import * as React from "react";
import { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { partnerService } from "../../services/api/partner.service";

export const ConsultationPatientInvestigations = (props) => {

    const [perPage] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowClicked, setRowClicked] = useState(null);
    const [searchText, setSearchText] = useState(""); // Adăugăm starea pentru textul căutat

    const [data, setData] = useState([]);


    useEffect(() => {
        let params = props.params;
        if (params != null && params != undefined && 
            params.data != null && params.data != undefined &&
            params.pacient != null && params.pacient != undefined &&
            params.locatie != null && params.locatie != undefined &&
            params.abonament != null && params.abonament != undefined &&
            params.tip != null && params.tip != undefined) {
            partnerService.getPatientInvestigations(props.params)
                .then(response => {
                    if (response) {
                        setData(response);
                    }
                    else
                        setData([]);
                });
        }
    }, [])



    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setCurrentPage(1); // Resetăm pagina când utilizatorul introduce text nou pentru a afișa rezultatele filtrate de la pagina 1
    };

    const paginate = (pageNumber) => {
        setRowClicked(null);
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

    // Filtrăm lista în funcție de textul căutat
    const filteredItems = data.filter((item) =>
        item.investigatie.toLowerCase().includes(searchText.toLowerCase())
    );

    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelect = (item) => {
        props.handleDialog();
    };

    return (
        <Dialog title={props.title ?? ""} onClose={props.handleDialog}>
            <table style={{ margin: "10px", width: "940px" }} >
                <thead>
                    <tr>
                        <th>Nr.</th>
                        <th>Investigatie</th>
                        <th className="center">Contractat</th>
                        <th className="center">Necesita preautorizare</th>
                    </tr>
                </thead>
                <tbody>
                {currentItems.map((item, index) => (
                    <tr
                        key={index}
                        onClick={() => setRowClicked(index)}
                        className={
                            
                            rowClicked !== null && rowClicked === index
                                ? "dwgrid_sel fs12"
                                : "fs12"
                        }>
                        <td style={{ fontSize: "12px" }}>{(currentPage - 1) * perPage + index + 1}</td>
                        <td style={{ fontSize: "12px" }}>{item.investigatie}</td>
                        <td style={{ fontSize: "12px" }} className="center">{item.areContract}</td>  
                        <td style={{ fontSize: "12px" }} className="center">{item.necesitaPreautorizare}</td>   
                    </tr>
                    ))}
                        
                </tbody>
            </table>
            

            <div className="w600 ">
                {/* Adăugăm evenimentul de schimbare a căutării */}
                <Input
                    name="search"
                    placeholder="Caută"
                    className="fl w300"
                    value={searchText}
                    onChange={handleSearchChange}
                />
                <Button icon="search" themeColor={"primary"} className="">
                    Cauta
                </Button>
            </div>

            <div className="mt20">
                <div className="w70 fl mt5">
                    <span className="">
                        {(currentPage - 1) * perPage + 1}{" "}
                    </span>{" "}
                    - <span> {Math.min(currentPage * perPage, filteredItems.length)}</span>
                </div>
                <div className="fl">
                    <button
                        className="pagination-button"
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                    >
                        |&lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() =>
                            paginate(
                                Math.ceil(filteredItems.length / perPage)
                            )
                        }
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;|
                    </button>
                </div>
            </div>

            <DialogActionsBar>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={() => handleSelect(rowClicked)}
                >Inchide</button>
            </DialogActionsBar>
        </Dialog>
    );
};
